const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/settings/teams/route.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { z } from 'zod';
import { requirePermission } from '@/common/hooks/usePermissions';
import i18n from '@/common/translations/i18n';
import { ensureNamespaceLoaded } from '@/common/translations/i18nloader';
import { compactPicklistFilterSchema } from '@/common/zod-schemas/common/compactFilterSchemas';
import { getTeamsQueryOptions } from '@/features/teams/queries/useGetTeamsQuery';
import { teamsDialogsSchema } from '@/features/teams/types';
export const teamsSearchSchema = z.object({
  dialog: teamsDialogsSchema.optional(),
  roleId: compactPicklistFilterSchema,
  loopId: compactPicklistFilterSchema,
  skillId: compactPicklistFilterSchema
});
export const Route = createFileRoute('/(app)/org/$org/settings/teams')({
  validateSearch: zodValidator(teamsSearchSchema),
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  beforeLoad: async ctx => {
    await requirePermission('edit_capacity')(ctx);
    await ensureNamespaceLoaded('teams');
  },
  loader: ({
    context: {
      queryClient
    }
  }): LoaderData => {
    queryClient.ensureQueryData(getTeamsQueryOptions());
    return {
      crumb: i18n.t($ => $.common.teams)
    };
  }
});